import type { Action } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { WebSocketClientStatus } from "./constants";
import { SocketStatus } from "./constants";

const SOCKET_STATUSES = Object.values(SocketStatus) as string[];

type WebSocketClientState = {
  status: WebSocketClientStatus;
  isRunning: boolean;
};

const initialState: WebSocketClientState = {
  status: SocketStatus.IDLE,
  isRunning: false,
};

export const websocketManagerSlice = createSlice({
  name: "websocketManager",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action): action is Action<WebSocketClientStatus> =>
        SOCKET_STATUSES.includes(action.type),
      (state, action) => {
        state.status = action.type;
        state.isRunning = action.type === SocketStatus.RUNNING;
      },
    );
  },
});
